module.exports = __webpack_public_path__ + "static/media/spinner-blue.329021a1.svg";